import { Button, Stack, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AlenDevice } from "src/interfaces/IAlenDevice";
import { WYND_WHITE } from "src/styles";
import {
  DeviceActionPayload,
  DeviceDetail,
  performDeviceActions,
} from "src/services/alen/performDeviceActions";
import { AuthContext } from "src/contexts/AuthContext";
import { getCommonActions } from "src/services/alen/utils/actions";
import AlenBulkActionModal, {
  AlenBulkActionOption,
} from "./AlenBulkActionModal";

export default function SelectedDeviceActionCard({
  selectedDevices,
  setSelectedDeviceIds = () => {},
  onActionPerformed,
}: {
  selectedDevices: AlenDevice[];
  setSelectedDeviceIds?: React.Dispatch<React.SetStateAction<string[]>>;
  onActionPerformed: () => void;
}) {
  const [availableAction, setAvailableAction] = useState<
    AlenBulkActionOption[]
  >([]);
  const [alenBulkActionOpened, setAlenBulkActionOpened] = useState(false);
  const { user } = useContext(AuthContext);
  useEffect(() => {
    setAvailableAction(getCommonActions(selectedDevices));
  }, [selectedDevices]);

  const handleExecute = async ({
    actionName,
    actionValue,
  }: {
    actionName: string;
    actionValue: string;
  }) => {
    if (!user?.alen) return;
    const deviceDetails: DeviceDetail[] = [];
    selectedDevices.forEach((device) => {
      if (deviceDetails.find((dd) => dd.productId === device.product_id)) {
        deviceDetails
          .find((dd) => dd.productId === device.product_id)
          ?.deviceIds.push(device.id);
      } else {
        deviceDetails.push({
          productId: device.product_id,
          deviceIds: [device.id],
        });
      }
    });
    const payloads: DeviceActionPayload = {
      actionName,
      actionValue,
      actionType: "Bulk",
      deviceDetails,
    };
    try {
      await performDeviceActions(user.alen, payloads);
      onActionPerformed();
      setAlenBulkActionOpened(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
        backgroundColor: WYND_WHITE,
        position: "sticky",
        transform: `translateX(-12px)`,
        bottom: "2rem",
        justifyContent: "space-between",
        padding: "1rem",
      }}
    >
      <Stack direction="row">
        <Typography>{selectedDevices.length} Selected</Typography>
      </Stack>
      <Stack direction="row">
        <Button
          onClick={() => setAlenBulkActionOpened(true)}
          variant="outlined"
          sx={{ backgroundColor: "white" }}
        >
          Bulk Action
        </Button>
      </Stack>
      {alenBulkActionOpened && (
        <AlenBulkActionModal
          setSelectedDeviceIds={setSelectedDeviceIds}
          options={availableAction}
          open={alenBulkActionOpened}
          onClose={() => setAlenBulkActionOpened(false)}
          onExecute={handleExecute}
          selectedDevices={selectedDevices}
        />
      )}
    </Stack>
  );
}
